import { Button } from "@/components/ui/button";
import handlePrint from "@/utils/handlePrint";
import { PrinterIcon, Loader2 } from "lucide-react";
import { PurchaseOrder } from "@/v2/types";
import PurchaseOrderPdf from "./PurchaseOrderPdf";
import { useState } from "react";
import PrintAddressDialog from "../../print/common/AddressDialog";
import { Branches } from "@/v2/constants";

export default function PrintPurchaseOrder({
    data,
    isInside = false,
}: {
    data: PurchaseOrder;
    isInside?: boolean;
}) {
    const [isPrinting, setIsPrinting] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [branch, setBranch] = useState<Branches>("JUBAIL");

    const onConfirmPrint = async () => {
        try {
            setIsPrinting(true);
            setDialogOpen(false);
            await handlePrint(
                <PurchaseOrderPdf data={data} addressBranch={branch} />,
                {
                    fileName: data.purchase_order_number,
                },
            );
        } catch (err) {
            console.error("Failed to print purchase order", err);
        } finally {
            setIsPrinting(false);
        }
    };

    return (
        <>
            <Button
                size="sm"
                variant={isInside ? "default" : "outline"}
                onClick={() => setDialogOpen(true)}
                disabled={isPrinting}
            >
                {isPrinting ? (
                    <>
                        <Loader2 className="h-4 w-4 animate-spin" />
                        {isInside && "Generating..."}
                    </>
                ) : (
                    <>
                        <PrinterIcon className="h-4 w-4" />
                        {isInside && "Print"}
                    </>
                )}
            </Button>

            <PrintAddressDialog
                open={dialogOpen}
                setOpen={setDialogOpen}
                branch={branch}
                setBranch={setBranch}
                onConfirmPrint={onConfirmPrint}
            />
        </>
    );
}
